<div class="header">
  <p>Depositar</p>
</div>
<div class="body fs-body">
  <p>
    Para abonar saldo a tu cuenta Monific, debes de enviar un SPEI o transferencia
    electrónica desde tu banco a tu cuenta <strong>CLABE personalizada de Monific</strong>.
    <a class="cl-sec-purple fw-sbold" href="https://www.youtube.com/watch?v=7D7k51i-tZk&feature=youtu.be"
      target="_blank">Ver video</a>
  </p>

  <p class="fs-12 mb-1">1. Ingresa a tu banco y selecciona transferir a una nueva cuenta.</p>
  <p class="fs-12 mb-1">2. <strong>En el listado de bancos, selecciona STP o Sistema de Transferencia y Pagos.</strong>
  </p>
  <p class="fs-12 mb-1">3. En el campo de beneficiario ingresa tu nombre.</p>
  <p class="fs-12 mb-1">4. Ingresa tu cuenta Clabe personalizada.</p>

  <div class="container-clabe mt-3">
    <div class="d-flex justify-content-between mb-2">
      <div>
        <p class="mb-0 fw-sbold cl-primary-3">CLABE</p>
        <p class="mb-0 fw-sbold info">{{ clabe }}</p>
      </div>
      <img (click)="copyClabe()" height="20" class="my-auto" src="assets/icon/copy.svg" alt="">
    </div>
  </div>

  <p class="fs-12 mb-1">
    En el concepto y en la referencia ingresa el dato que tu desees para identificar el
    movimiento.</p>

  <div class="w-100 text-center mb-4">
    <button mat-button (click)="close()">Entendido</button>
  </div>

  <div class="text-right">
    <p class="fs-11 mb-0 cl-primary-7">*Tu saldo lo verás reflejado de inmediato o en un máximo de 2 horas.</p>
  </div>

</div>
